import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Barcode from './barcode.vue'

export type barcodeFormat =
  | 'CODE39'
  | 'CODE128'
  | 'CODE128A'
  | 'CODE128B'
  | 'CODE128C'
  | 'EAN13'
  | 'EAN8'
  | 'UPC'
  | 'ITF14'
  | 'codabar'
  | 'codabar'
  | 'codabar'
  | 'ITF'
  | 'CODE93'

// 定义组件props
export const barcodeProps = buildProps({
  // 编码值
  value: {
    type: String,
    default: '',
  },

  // 编码格式
  format: {
    type: definePropType<barcodeFormat>(String),
    default: 'CODE128',
  },

  // 单个条码宽度
  width: {
    type: Number,
    default: 2,
  },

  // 条码高度
  height: {
    type: Number,
    default: 50,
  },

  // 是否显示文本值
  displayValue: {
    type: Boolean,
    default: true,
  },

  // 文本对齐方式
  textAlign: {
    type: definePropType<'left' | 'center' | 'right'>(String),
    default: 'center',
  },

  // 文本位置
  textPosition: {
    type: definePropType<'top' | 'bottom'>(String),
    default: 'bottom',
  },

  // 文本与条码的间距
  textMargin: {
    type: Number,
    default: 2,
  },

  // 文本字体大小
  fontSize: {
    type: Number,
    default: 20,
  },

  // 背景颜色
  background: {
    type: String,
    default: '#ffffff',
  },

  // 条码颜色
  lineColor: {
    type: String,
    default: '#000000',
  },

  // 整体边距
  margin: {
    type: Number,
    default: 10,
  },
} as const)

// props
export type BarcodeProps = ExtractPropTypes<typeof barcodeProps>

// instance
export type BarcodeInstance = InstanceType<typeof Barcode>
